/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeModel } from '../../models/employee-model';

export interface GetAttorney$Json$Params {

/**
 * id of attorney for filter
 */
  attorneyId: number;
}

export function getAttorney$Json(http: HttpClient, rootUrl: string, params: GetAttorney$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeModel>> {
  const rb = new RequestBuilder(rootUrl, getAttorney$Json.PATH, 'get');
  if (params) {
    rb.path('attorneyId', params.attorneyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeModel>;
    })
  );
}

getAttorney$Json.PATH = '/api/Attorney/{attorneyId}';
